import { useState, useRef, useEffect } from "react";

// Username dropdown in the top menu. Holds Logout today; structured so future
// items (Settings, etc.) drop in without restructuring. `login` may be null for a
// pre-migration row — fall back to a neutral label rather than rendering "@null".
//
// "Forget this device" is hidden for now (2026-06-04) but its handler + wiring
// (onForgetDevice / remembered) are left intact so it can be restored.
export function UserMenu({
  login,
  remembered,
  onForgetDevice,
  onSignOut,
}: {
  login: string | null;
  remembered: boolean;
  onForgetDevice: () => void;
  onSignOut: () => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDocPointer = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDocPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="user-menu" ref={ref}>
      <button
        type="button"
        className="user-menu-trigger"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        {login ? `@${login}` : "Account"} ▾
      </button>
      {open && (
        <div className="user-menu-popover" role="menu">
          {false && remembered && (
            <button
              type="button"
              role="menuitem"
              className="user-menu-item"
              onClick={() => {
                setOpen(false);
                onForgetDevice();
              }}
            >
              Forget this device
            </button>
          )}
          <button
            type="button"
            role="menuitem"
            className="user-menu-item"
            onClick={() => {
              setOpen(false);
              onSignOut();
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;
